import { gql } from '@apollo/client';

export const USER_DETAILS = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
    }
  }
`;
